export default __webpack_public_path__ + "static/media/screen_zendesk_5.078cda25.png";